/**
 * Modern Providers for Lobby2.0
 * Replaces old Context pattern with modern provider structure
 */

import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from 'styled-components';
import { I18nextProvider } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import { theme } from 'styles/theme';
import { GlobalStyles } from 'styles/GlobalStyles';
// import { features } from '../config/features';
import i18n from '../../../i18n';
import { OpenTypeProvider } from './OpenTypeContext';
import { queryClient } from '../config/queryClient';
import 'react-toastify/dist/ReactToastify.css';

interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <GlobalStyles theme={theme} />
        <I18nextProvider i18n={i18n}>
          <OpenTypeProvider>
            {children}
            <ToastContainer
              position="bottom-right"
              autoClose={false}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick={false}
              rtl={false}
              pauseOnFocusLoss
              draggable={false}
              pauseOnHover
              theme="dark"
            />
            {/* {features.enableDevTools && <ReactQueryDevtools initialIsOpen={false} />} */}
          </OpenTypeProvider>
        </I18nextProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
